import { useNavigate } from 'react-router-dom';
import { Header, NavigationButton, SubTitle, Title, TitleContainer } from './MobileDetailsHeaderStyledComponents';
import { ReactNode } from 'react';

export type MobileDetailsHeaderProps = {
  title: string;
  titleRightElement?: ReactNode;
  subtitle: ReactNode;
};
export function MobileDetailsHeader({ title, titleRightElement, subtitle }: MobileDetailsHeaderProps) {
  const navigate = useNavigate();

  return (
    <Header>
      <NavigationButton onClick={() => navigate('/')} icon="arrowLeft" size="x-large" variant="primary" />
      <TitleContainer>
        <Title>{title}</Title>
        {titleRightElement}
      </TitleContainer>
      <SubTitle>{subtitle}</SubTitle>
    </Header>
  );
}
